var _hooksUseAcquisitionPopupQuery;
import { useEffect } from "react";
import { graphql, useFragment } from "react-relay";
import { useSdkContext } from "~/components/contexts";
import { MyNewsConfig } from "./popups/my-news/data";
export const useAcquisitionPopup = (options, queryReference) => {
  var _data$widgetConfig2;
  const {
    acquisition: {
      setPopupState
    }
  } = useSdkContext();
  const data = useFragment(_hooksUseAcquisitionPopupQuery !== void 0 ? _hooksUseAcquisitionPopupQuery : (_hooksUseAcquisitionPopupQuery = require("../../../queries/__generated__/hooksUseAcquisitionPopupQuery.graphql"), _hooksUseAcquisitionPopupQuery.hash && _hooksUseAcquisitionPopupQuery.hash !== "e9738b90264ec450dc22909225ffbc57" && console.error("The definition of 'hooksUseAcquisitionPopupQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _hooksUseAcquisitionPopupQuery), queryReference);
  useEffect(() => {
    var _data$widgetConfig;
    if (!(data !== null && data !== void 0 && (_data$widgetConfig = data.widgetConfig) !== null && _data$widgetConfig !== void 0 && _data$widgetConfig.json)) return;
    const rawWidgetConfig = data.widgetConfig.json;
    const widgetConfig = rawWidgetConfig[options.configEnvironmentSlug];
    const popupState = Object.entries(widgetConfig).reduce((state, [key, config]) => {
      const normalizedKey = key.toUpperCase();
      if (normalizedKey.startsWith("ACQUISITION_NL_")) {
        state.acquisitions[key] = config;
      } else if (normalizedKey.startsWith("ACQUISITION_WHY_REGISTER_")) {
        state.whyRegister[key] = config;
      } else if (normalizedKey.startsWith("CAMPAIGN_POPUP_")) {
        state.campaigns[key] = config;
      } else if (normalizedKey.startsWith("TOPIC_PACKAGE_FOLLOW_POPUP_")) {
        state.topicPackageFollows[key] = config;
      }
      return state;
    }, {
      acquisitions: {},
      campaigns: {},
      myNews: {
        config: widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.my_news,
        ...MyNewsConfig
      },
      topicPackageFollows: {},
      whyRegister: {}
    });
    setPopupState(popupState);
  }, [data === null || data === void 0 || (_data$widgetConfig2 = data.widgetConfig) === null || _data$widgetConfig2 === void 0 ? void 0 : _data$widgetConfig2.json, options.configEnvironmentSlug, setPopupState]);
};